<div class="gse-limit-container" *ngIf="!containsError">
  <div>
    <span class="pageHeader" id="updateGseTableHeader">
      Update GSE Table
		</span>
  </div>
  <br><br><br>
  <div *ngIf="successMess">
    <div class="successMessAlign">
      <p>
      <li>System Attribute has been successfully updated.</li>
      </p>
    </div>
  </div>
  <div class="errorMessage" *ngIf="showErrorDiv">
    <p>{{errHeading}}</p>
    <p>
    <li> {{errMessage}}</li>
    </p>
  </div>
  <span class="adminTblAlign">
        <div class="ui-g-3 lblAlign"> State:  </div>
        <div class="ui-g-3">   <fm-select
          [options]="state"
          [(ngModel)]="selectedState"
          ariaLabelledBy="default"
        ></fm-select></div>
      </span>
  <div class="btnAlign">
    <button fmButton type="button" [small]="true" [primary]="true" label="Search" class="dispbuttonMargin"
            (click)="getGseLimit()"></button>
    <button fmButton type="button" routerLink="/admin" [small]="true" label="Cancel" class="dispbuttonMargin"></button>
    <a href="" class="hrefMargin"> GSE Report </a>
  </div>
  <br><br>
  <div class="resultTbl" *ngIf="showVal">
    <table class="lblAlign">
      <tr>
        <td>State :</td>
        <td class="resultLblAlign">{{displayState}}</td>
      </tr>
      <tr>
        <td>Current Value :</td>
        <td class="resultLblAlign">$ {{currentVal  | number : '1.2-2'}} </td>
      </tr>
      <tr>
        <td> New Value :</td>
        <td class="resultLblAlign"><input type="text" fmTextInput (keyup)="trackKeyPress($event)" [(ngModel)]="updatVal" maxlength="11"></td>
      </tr>
    </table>
    <div>
      <button fmButton type="button" [small]="true" label="Update" class="dispbuttonMargin" [primary]="true"
              (click)="updateGseLimit()"></button>
    </div>
  </div>
</div>
<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>

